







































import JsonViewer from 'vue-json-viewer'
import { Vue, Component } from "vue-property-decorator";
import {Mutation, Getter} from "vuex-class";
import axios from "axios";
import AmGroups from "@/valchrom/views/dataset/AmGroups.vue";
import AssessmentMethodOrder from "@/valchrom/AssessmentMethodOrder";
import BButton from "buefy/src/components/button/Button.vue";

@Component({
    components: {
        BButton,
        AmGroups,
        JsonViewer,
    }
})
export default class ReportView extends Vue {
    name= "ReportView";

    component_url = 'experiments/datasets/';
    currentExperimentalDataset: any = {};

    dataLoaded = false;
    overviewResponse: any;
    reportHtml : string = "";

    // map getters
    @Getter base_url !: any;
    @Getter auth_header !: any;
    @Getter overview_simplify !: boolean;

    @Mutation CHANGE_OVERVIEW_SIMPLIFY!: (_ : boolean) => any; //TODO: add type
    @Mutation SET_BREADCRUMB!: (_ : any) => any; //TODO: add type
    @Mutation CHANGE_EXPERIMENTAL_DATASET_ID!: (_ : any) => any;

    mounted () {

        this.CHANGE_OVERVIEW_SIMPLIFY(true);
        this.setBreadcrumb();
        this.currentExperimentalDataset.id = this.$route.params.datasetId;
        //set experimentalDataset id in vuex
        this.setExperimentalDatasetId();

        axios
            .get(
                this.base_url+this.component_url +
                this.currentExperimentalDataset.id,
                {
                    headers: this.auth_header,
                }
            )
            .then(response => {
                this.currentExperimentalDataset = response.data
            })
            .catch(error => {
                console.log("Something went wrong getting the current Dataset", error);
            });

        axios.get(
                this.base_url+'experiments/overview/' +
                this.currentExperimentalDataset.id + "/result",
                {
                    params: this.$route.query,
                    headers: this.auth_header,
                }
            ).then(response => {
                this.dataLoaded = true;

                setTimeout(()=>{
                    let allAmsHtml = (this.$refs.all_ams as Element).innerHTML;
                    this.reportHtml = allAmsHtml;
                },10);


                this.overviewResponse = response.data;

                //sort ams by code_name
                let analytes = this.overviewResponse.analytes;
                for(let analyteId in analytes){
                    let amGroups = analytes[analyteId].am_groups;
                    for(let amGroupId in amGroups){
                        let amGroup = amGroups[amGroupId];
                        let ams = amGroup.ams;
                        const orderedAms = [];
                        for(let amCode in ams){
                            let am = ams[amCode];
                            am.code = amCode;
                            orderedAms.push(am);
                        }
                        let sorter = (am1: any,am2: any)=>{
                            return AssessmentMethodOrder.indexOf(am1.code_name) -
                                AssessmentMethodOrder.indexOf(am2.code_name)
                        };
                        orderedAms.sort(sorter);
                        amGroup.ams = {};
                        for(let am of orderedAms) {
                            amGroup.ams[am.code] = am
                        }
                    }
                }
            })
            .catch(error => {
                console.log("Something went wrong getting the result", error);
            });

    }

    //original methods
    setBreadcrumb(){
        this.SET_BREADCRUMB(this.$route.meta.breadcrumb)
    }

    //set global ExperimentalDatasetId
    setExperimentalDatasetId(){
        this.CHANGE_EXPERIMENTAL_DATASET_ID(this.currentExperimentalDataset.id)
    }

    handleBack(){
        this.$router.push({ name: "ViewAllExperimentalDatasets", params: { } });
    }

}
